module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4mxK.aa23b7b4.woff2";